import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HomeService } from '../_services/home.service';
import { LoadingService } from '../_services/loading.service'
import { finalize } from 'rxjs/operators';
@Component({
  selector: 'app-privacy-polity',
  templateUrl: './privacy-polity.component.html',
  styleUrls: ['./privacy-polity.component.scss']
})
export class PrivacyPolityComponent implements OnInit {
  privacyContent: string | null = null;
  projectName: string = "Property";

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private homeService: HomeService,
    private cd: ChangeDetectorRef,
    private loadingService: LoadingService,
  ) { }

  ngOnInit(): void {
    this.getprofession_details(this.projectName);
  }

  getprofession_details(projectName: string): void {
    this.loadingService.show();
    this.homeService.getprofession_details(projectName)
      .pipe(finalize(() => this.loadingService.hide()))
      .subscribe(
        (response: any) => {
          if (response.status === 'SUCCESS') {
            // grab the very last PrivacyPolicy
            const latest = response.payload
              .filter((item: any) => item.type === 'PrivacyPolicy')
              .pop();
            if (!latest) {
              console.error('No PrivacyPolicy found');
              return;
            }

             let content = latest.content.replace(/G3G/g, 'FuProp');

             content = content.replace(/\r\n/g, '\n');

             content = content.replace(
               /^\s*(?:\d+|[A-Za-z])(?:[.)]\s*(?:\d+|[A-Za-z]))*[.)]?\s*/gm,
               ''
             );

             // now split & wrap:
             const lines = content
               .split('\n')
               .map(l => l.trim())
               .filter(l => l.length > 0);

             this.privacyContent = lines
               .map(l => `<pre>${l}</pre>`)
               .join('');

          } else {
            console.error('Response status is not SUCCESS');
          }
        },
        err => console.error('API error', err)
      );
  }




}
